import { getError } from '@autobid/strapi-integration/utils/getError'
import { useQuery } from '@tanstack/vue-query'

export const USE_CURRENCIES_TANSTACK_KEY = ['currencies']

export function useCurrencies(enabled: Ref<boolean>) {
  const { $trpc } = useNuxtApp()

  const fetchFn = async () => {
    try {
      return await $trpc.auctions.getCurrencies.query()
    }
    catch (error) {
      const { message, code, handled } = getError(error)

      if (!handled) {
        throw createError({ statusCode: code, statusMessage: message })
      }
    }
  }

  return useQuery(USE_CURRENCIES_TANSTACK_KEY, fetchFn, {
    enabled,
    refetchOnWindowFocus: false,
  })
}
